// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7047":"d281ff88","7379":"b29c0b70","7937":"b29c0b70","8109":"b29c0b70"}[chunkId] + ".chunk.css";
};